<app-header></app-header>
<!--<div class="project-fir-page">-->
<div class="content_wrapper">
    <div class="summary-head mention-sec">
        <div class="wrapper">
            <span class="heading-period">
                <div class="summary-title">
                    <i class="fa fa-heart-o"></i><h2 class="">Activities</h2>
                </div>
            </span>
            <div class="datepicker-wrapper">
                <span class="heading-period"><span>Pick a date range and period :</span></span>
                <div class="periodpicker-wrapper">

                </div>
                <div class="popover-wrapper">
                    <input type="text"
                           ngxDaterangepickerMd
                           [(ngModel)]="selected"
                           [alwaysShowCalendars]="alwaysShowCalendars"
                           [ranges]="ranges"
                           [showClearButton]="false"
                           [showCancel]="true"
                           [linkedCalendars]="true"
                           [locale]="{applyLabel: 'Apply'}"
                           (datesUpdated)="datesUpdated($event)"
                           [keepCalendarOpeningWithRange]="keepCalendarOpeningWithRange"
                           [showRangeLabelOnInput]="showRangeLabelOnInput"
                           class="form-control" placeholder="Created date range"/>
				</div>
				<div class="popover-wrapper">		   
					<input type="text" id="search_term" placeholder="Name or Email">	   
                </div>
				<div class="popover-wrapper">		   
					<select id="type_filter">
						<option value="">All</option>
						<option value="login">Login</option>
						<option value="logout">Logout</option>
						<option value="pdf">PDF Report</option>
						<option value="excel">Excel Report</option>
					</select>
                </div>
				<button (click)="user_search()" class="submit-mention btn" type="button">Search</button>
            </div>
        </div>
    </div>
    <!--first row-->
    <div class="row">

        <div class="col col-md-12">
            <div class="summary-graph">
                <!--tbl sec-->
                <div class="summary-tbl project_tbl">
                    <table>
                        <thead>
                            <tr>
                                <td role="button" (click)="data_order_by(0)" class="{{order_by == 0 ? 'active-sort' : 'inactive-sort'}}">
                                    <div class="diff-sec">
                                        <h3>Date</h3><i class="fa {{table_options[0] == 'desc' ? 'fa-sort-desc' : 'fa-sort-asc'}}" aria-hidden="true"></i>
                                    </div>
                                </td>
                                <td (click)="data_order_by(1)" class="{{order_by == 1 ? 'active-sort' : 'inactive-sort'}}">
                                    <div class="diff-sec">
                                        <h3>User</h3><i class="fa {{table_options[1] == 'desc' ? 'fa-sort-desc' : 'fa-sort-asc'}}" aria-hidden="true"></i>
                                    </div>
                                </td>
								<td (click)="data_order_by(2)" class="{{order_by == 2 ? 'active-sort' : 'inactive-sort'}}">
                                    <div class="diff-sec">
                                        <h3>Email</h3><i class="fa {{table_options[2] == 'desc' ? 'fa-sort-desc' : 'fa-sort-asc'}}" aria-hidden="true"></i>
                                    </div>
                                </td>
								<td (click)="data_order_by(3)" class="{{order_by == 3 ? 'active-sort' : 'inactive-sort'}}">
                                    <div class="diff-sec">
                                        <h3>Last Active</h3><i class="fa {{table_options[3] == 'desc' ? 'fa-sort-desc' : 'fa-sort-asc'}}" aria-hidden="true"></i>
                                    </div>
                                </td>
                                <td>
                                    <div class="diff-sec">
                                        <h3>Action</h3>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let log of logs | paginate: { itemsPerPage: page_length, currentPage: page, totalItems: total }">
                                <td>{{log.datetime_created}}</td>
                                <td>{{log.name}}</td>
                                <td>{{log.email}}</td>
                                <td>{{log.last_active}}</td>
								<td>{{log.details}}</td>
<!--                                <td>
                                    <a (click)="delete_user(user.id)"><span><img src="assets/images/delete.png"></span>Delete</a></td>-->
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="mention-card">
                    <div class="paginate_sec_bottom">
                        <pagination-controls (pageChange)="pageChanged($event)" responsive="true"></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--</div>-->
<app-footer></app-footer>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="rgb(199, 28, 109)" type="square-loader" [fullScreen]="true"></ngx-spinner>
